import { useQueryParam } from '../utils/useQueryParam';
import { DateFilterType, DEFAULT_FILTER_VALUES } from '../constants/filters';
import { UserTicketViewOption } from '../data/types';
import { usePortalData } from '../data/usePortalData';
import { useCallback, useEffect, useRef } from 'react';
export const useTicketListingsFilters = () => {
  const didMountRef = useRef(false);
  const {
    data
  } = usePortalData();
  const [sort, setSort] = useQueryParam('sort', ['-createdate'], JSON.parse);
  const [offset, setOffset] = useQueryParam('offset', 0, Number);
  const [createDateFilter, setCreateDateFilter] = useQueryParam('createdate', DEFAULT_FILTER_VALUES.createDateFilter);
  const [lastActivityFilter, setLastActivityFilter] = useQueryParam('hs_lastactivitydate', DEFAULT_FILTER_VALUES.lastActivityFilter);
  const [statusFilter, setStatusFilter] = useQueryParam('statusFilter', DEFAULT_FILTER_VALUES.statusFilter);
  const [ticketView, setTicketView] = useQueryParam('ticketView', DEFAULT_FILTER_VALUES.ticketView);
  const [searchString, setSearchString] = useQueryParam('searchString', '');

  // The following sets filters depending on what the portal settings
  // allow and what the user permissions allow.
  if (data) {
    const {
      configuredTicketProperties,
      userTicketViewOptions
    } = data;
    if (!configuredTicketProperties.find(({
      propertyName
    }) => propertyName === 'createdate') && createDateFilter !== DateFilterType.ALL_TIME) {
      setCreateDateFilter(DateFilterType.ALL_TIME);
    }
    if (!configuredTicketProperties.find(({
      propertyName
    }) => propertyName === 'hs_lastactivitydate') && lastActivityFilter !== DateFilterType.ALL_TIME) {
      setLastActivityFilter(DateFilterType.ALL_TIME);
    }
    if (!userTicketViewOptions.includes(UserTicketViewOption.COMPANY) && ticketView !== UserTicketViewOption.PERSONAL) {
      setTicketView(UserTicketViewOption.PERSONAL);
    }
    if (sort.length === 0) {
      setSort(['-createdate']);
    }
  }
  const resetFilters = useCallback(() => {
    setStatusFilter(DEFAULT_FILTER_VALUES.statusFilter);
    setCreateDateFilter(DEFAULT_FILTER_VALUES.createDateFilter);
    setLastActivityFilter(DEFAULT_FILTER_VALUES.lastActivityFilter);
  }, [setStatusFilter, setCreateDateFilter, setLastActivityFilter]);
  const resetSort = useCallback(() => {
    setSort(['-createdate']);
  }, [setSort]);

  // When filters or sort change, reset the offset
  useEffect(() => {
    // Do not reset offset on initial mount:
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    setOffset(0);
  }, [sort, ticketView, statusFilter, searchString, createDateFilter, lastActivityFilter, setOffset]);
  return {
    setLastActivityFilter,
    setCreateDateFilter,
    setSearchString,
    setStatusFilter,
    setTicketView,
    setOffset,
    setSort,
    sort,
    offset,
    ticketView,
    statusFilter,
    searchString,
    createDateFilter,
    lastActivityFilter,
    resetFilters,
    resetSort
  };
};